export default {"src":"/_next/static/media/toggle.3faef41e.svg","height":34,"width":45,"blurWidth":0,"blurHeight":0};